/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import IdCard from '../IdCard'
import { Box, Center } from '@chakra-ui/react'
import defaultProfilePic from '../../assets/images/profile.png'
import { useAuthContext } from '../../context/auth.context'
import { useLoadAwsFile } from '../../hooks/asset.hooks'
import { useHistory } from 'react-router'
import { useLanguageContext } from '../../context/locale.context'
import { motion } from 'framer-motion'

const IdCardScreen = props => {
	const {
		employee_first_name,
		employee_designation,
		employee_organization,
		account_name,
		profilePic,
		orgPic,
		orgColor,
	} = props

	const {
		state: { authData },
	} = useAuthContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const history = useHistory()
	const [loadingWidth, setLoadingWidth] = useState('100px')
	const { mutate, isLoading: isLoadingAWS } = useLoadAwsFile()

	const { asset_image_path } = authData

	const callbackFunc = response => {
		setLoadingWidth('240px')
	}

	useEffect(() => {
		if (!!asset_image_path) {
			setTimeout(() => {
				mutate({
					fileUrl: asset_image_path,
					cb: callbackFunc,
				})
			}, 1000)
		}
	}, [])

	useEffect(() => {
		if (asset_image_path === '') {
			setLoadingWidth('240px')
		} else if (!!asset_image_path) {
			setTimeout(() => {
				mutate({
					fileUrl: asset_image_path,
					cb: callbackFunc,
				})
			}, 1000)
		}
	}, [authData])

	useEffect(() => {
		if (loadingWidth === '240px') {
			setTimeout(() => {
				history.push('/idcard')
			}, 500)
		}
	}, [loadingWidth])

	return (
		<>
			<Box
				position='absolute'
				w='100%'
				h='100vh'
				mx='auto'
				top='0px'
				zIndex='11'
				bg='linear-gradient(225deg, #009B76 0%, #016F54 100%)'
			>
				<Box mt='75px'>
					<IdCard
						name={employee_first_name}
						org={employee_organization}
						account={account_name}
						asset_type_name={employee_designation}
						profileImageData={profilePic}
						defaultProfilePic={defaultProfilePic}
						orgLogo={!!orgPic ? orgPic : 'defaultOrgIcon'}
						orgColor={orgColor}
					/>
				</Box>
				<Center height='22px' mt='65px'>
					<Box
						minW='76px'
						fontStyle='normal'
						fontWeight='400'
						fontSize='16px'
						lineHeight='22px'
						textAlign='center'
						letterSpacing='0.2px'
						color='#FFFFFF'
					>
						{!locale['Loading'] ? 'Loading' : locale['Loading']}...
					</Box>
				</Center>
				<Center h='6px' mt='16px'>
					<Box
						width='250px'
						height='6px'
						background='rgba(0, 0, 0, 0.25)'
						mixBlendMode='normal'
						opacity='0.9'
						borderRadius='5px'
					>
						<Box
							as={motion.div}
							initial={{ width: 0 }}
							animate={{
								width: loadingWidth,
								transition: { width: { duration: 1 } },
							}}
							height='6px'
							background='#f4f4f4'
							borderRadius='5px'
						></Box>
					</Box>
				</Center>
			</Box>
		</>
	)
}

export default IdCardScreen
